import { ShadcnAutoCompleteFilters } from "Explore/Components";
import { getSuggestKeywords } from "Explore/Services/Common";

const FiltersVenueLandscape = ({ filters, setFilters }) => {
  return (
    <div className="flex flex-col gap-6 p-4 border border-gray-100 rounded-md bg-white shadow-sm mt-4">
      <p className="text-sm font-semibold text-gray-800">
        Filters
      </p>
      
      <div className="flex flex-col gap-2">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Research area
        </label>
        <ShadcnAutoCompleteFilters
          placeholder={"Enter to search"}
          functionSearch={getSuggestKeywords}
          filters={filters}
          setFilters={setFilters}
          entity="keywordQuery"
          getFirstItemOnEnter
        />
      </div>
    </div>
  );
};

export default FiltersVenueLandscape;
